import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Agreement } from '../types';
import { ACTIVE_AGREEMENT_STORAGE_KEY } from '../constants';

interface AgreementStore {
  activeAgreement: Agreement | null;
  // Persisted separately so localStorage holds only a uuid, not the full object.
  // Hydration resolves the full Agreement from query data on next load.
  activeAgreementUuid: string | null;
  setActiveAgreement: (agreement: Agreement) => void;
  clearActiveAgreement: () => void;
}

export const useAgreementStore = create<AgreementStore>()(
  persist(
    (set) => ({
      activeAgreement: null,
      activeAgreementUuid: null,
      setActiveAgreement: (agreement) =>
        set({ activeAgreement: agreement, activeAgreementUuid: agreement.uuid }),
      clearActiveAgreement: () =>
        set({ activeAgreement: null, activeAgreementUuid: null }),
    }),
    {
      name: ACTIVE_AGREEMENT_STORAGE_KEY,
      partialize: (state) => ({ activeAgreementUuid: state.activeAgreementUuid }),
    },
  ),
);
